/**
 * Created by aaguilar
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('siatService', siatService);

    siatService.$inject = ['$http', 'CONFIG', 'messageService'];


    function siatService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/siat';
        var params = {
            administrationId: 1,
            enterpriseId: 2000,
            taxpayerId: 1
        };

        var service = {
            getActivities: getActivities,
            getProducts: getProducts,
            getProductsByCode: getProductsByCode
        };

        return service;

        function getActivities(){
            return $http.post(urlBase + "/activities", params)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getProducts(){
            return $http.post(urlBase + "/products", params)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getProductsByCode(code, products) {
            var list = [];
            for (var i = 0; i < products.length; i++) {
                if (products[i].codigoActividad === code) {
                    list.push(products[i])
                }
            }
            return list
        }
    }
})();
